import type { PathLookupDecisionEvent } from '@ipfabric/utils';

/**
 * Lock shape for a decision's severity icon. Shared by the on-prem grid and the
 * cloud table so the same verdict never renders two different icons; topics
 * without a lock semantic (FORWARDING) get no shape.
 */
export const getIconSeverityShapeClassName = (
  event: PathLookupDecisionEvent,
): string | undefined => {
  const { severityInfo } = event;
  switch (severityInfo?.severity) {
    case 0:
      switch (severityInfo.topic) {
        case 'ACL':
        case 'NAT44':
        case 'PBR':
        case 'ZONEFW':
          return 'fa-unlock-keyhole';
        default:
          return undefined;
      }
    case 30:
      switch (severityInfo.topic) {
        case 'ACL':
        case 'ZONEFW':
          return 'fa-lock-keyhole';
        default:
          return undefined;
      }
    default:
      return undefined;
  }
};
